"use strict";

(function (EWS) {
    const JsonPath = function (options) {
        options = Object.assign({}, {
            data: {},
            resultType: "VALUE",
            keepHistory: true,
            onFound(path, value) { },
            onNormalize(expression) { },
            onTrace(expression, value, path) { },
            onWalk(loc, expression, value, path, func) { }
        }, options);

        const P = {
            result: [],

            normalize(expr) {
                options.onNormalize(expr);

                const subx = [];

                return expr.replace(/[['](\??\(.*?\))[\]']|\['(.*?)'\]/g, ($0, $1, $2) => `[#${subx.push($1 || $2) - 1}]`).replace(/'?\.'?|\['?/g, ";").replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "")
                    .replace(/#([0-9]+)/g, ($0, $1) => subx[$1]);
            },

            asPath(path) {
                const x = path.split(";");
                let p = "$";

                for (let i = 1, n = x.length; i < n; i++) {
                    p += /^[0-9*]+$/.test(x[i]) ? (`[${x[i]}]`) : (`['${x[i]}']`);
                }

                return p;
            },

            store(p, v) {
                options.onFound(p, v);

                if (p) {
                    switch (options.resultType) {
                        case "PATH":
                            P.result[P.result.length] = P.asPath(p);
                            break;

                        case "BOTH":
                            P.result[P.result.length] = {
                                path: P.asPath(p),
                                value: v,
                                query: p
                            };

                            break;

                        default:
                        case "VALUE":
                            P.result[P.result.length] = v;
                            break;
                    }
                }

                return !!p;
            },

            trace(expr, val, path) {
                options.onTrace(expr, val, path);

                if (expr !== "") {
                    let x = expr.split(";");
                    const loc = x.shift();

                    x = x.join(";");

                    if (val && Object.prototype.hasOwnProperty.call(val, loc)) {
                        P.trace(x, val[loc], `${path};${loc}`);
                    } else if (loc === "*") {
                        P.walk(loc, x, val, path, (m, l, z, v, p) => {
                            P.trace(`${m};${z}`, v, p);
                        });
                    } else if (loc === "..") {
                        P.trace(x, val, path);

                        P.walk(loc, x, val, path, (m, l, z, v, p) => {
                            typeof v[m] === "object" && P.trace(`..;${z}`, v[m], `${p};${m}`);
                        });
                    } else if (/^\(.*?\)$/.test(loc)) {
                        P.trace(`${P.eval(loc, val, path.substr(path.lastIndexOf(";") + 1))};${x}`, val, path);
                    } else if (/^\?\(.*?\)$/.test(loc)) {
                        P.walk(loc, x, val, path, (m, l, x, v, p) => {
                            if (P.eval(l.replace(/^\?\((.*?)\)$/, "$1"), v instanceof Array ? v[m] : v, m)) {
                                P.trace(`${m};${x}`, v, p);
                            }
                        });
                    } else if (/^(-?[0-9]*):(-?[0-9]*):?([0-9]*)$/.test(loc)) {
                        P.slice(loc, x, val, path);
                    } else if (/,/.test(loc)) {
                        for (let s = loc.split(/'?,'?/), i = 0, n = s.length; i < n; i++) {
                            P.trace(`${s[i]};${x}`, val, path);
                        }
                    }
                } else {
                    P.store(path, val);
                }
            },

            walk(loc, expr, val, path, f) {
                if (val instanceof Array) {
                    for (let i = 0, n = val.length; i < n; i++) {
                        if (i in val) {
                            f(i, loc, expr, val, path);
                        }
                    }
                } else if (typeof val === "object") {
                    const keyArr = Object.keys(val);
                    for (let i = 0; i < keyArr.length; i++) {
                        const m = keyArr[i];
                        if (Object.prototype.hasOwnProperty.call(val, m)) {
                            f(m, loc, expr, val, path);
                        }
                    }
                }
            },

            slice(loc, expr, val, path) {
                if (val instanceof Array) {
                    const len = val.length;
                    let start = 0;
                    let end = len;
                    let step = 1;

                    loc.replace(/^(-?[0-9]*):(-?[0-9]*):?(-?[0-9]*)$/g, ($0, $1, $2, $3) => {
                        start = parseInt($1 || start);
                        end = parseInt($2 || end);
                        step = parseInt($3 || step);
                    });

                    start = (start < 0) ? Math.max(0, start + len) : Math.min(len, start);
                    end = (end < 0) ? Math.max(0, end + len) : Math.min(len, end);

                    for (let i = start; i < end; i += step) {
                        P.trace(`${i};${expr}`, val, path);
                    }
                }
            },

            eval(x, _v, _vname) {
                try {
                    return _v && eval(x.replace(/(^|[^\\])@/g, "$1_v").replace(/\\@/g, "@"));
                } catch (e) {
                    throw new SyntaxError(`jsonPath: ${e.message}: ${x.replace(/(^|[^\\])@/g, "$1_v").replace(/\\@/g, "@")}`);
                }
            },

            query(expression) {
                if (!options.keepHistory) {
                    P.result = [];
                }

                if (expression) {
                    P.trace(P.normalize(expression).replace(/^\$;?/, ""), options.data, "$");
                    return P.result.length ? P.result : false;
                }
                return null;
            }
        };

        return P;
    };

    EWS.Json = {
        Escape(value) {
            value = value.replace(/\(/g, "");
            value = value.replace(/\)/g, "");
            value = value.replace(/\//g, "");
            value = value.replace(/\\/g, "");
            value = value.replace(/\+/g, "");
            value = value.replace(/-/g, "");
            value = value.replace(/([.^$*'?()[{\\|])/g, "\\$1");

            return value;
        },

        Query(data, expression) {
            return JsonPath({
                data
            }).query(expression);
        }
    };
}(EWS));
